import React from 'react';

import arrow from 'assets/images/icons/back-desktop.svg';
import listIcon from 'assets/images/icons/list-icon.svg';
import pointer from 'assets/images/icons/mapPointer.svg';
import { Button, Heading } from 'components/Atoms';
import BackButton from 'components/BackButton';
import { InputGMPlaces } from 'components/Molecules';
import sizes from 'utils/screenSizes';

import * as T from './interfaces';
import * as S from './styles';

export const HeaderSearch = ({
  mode,
  onChangeSession,
  session,
  height,
  onChangeViewMode,
  changePlacesSuggestions,
  contentStyle,
  userIsLoggedIn,
}: T.IHeaderSearchProps) => (
  <S.SearchHeader
    session={session}
    mode={mode}
    id="searchHeaderContainer"
    height={height}
    style={contentStyle}
  >
    {window.screen.width < parseInt(sizes.notebook, 10) ? (
      <S.BackButtonIcon>
        <img src={arrow} alt="Seta para Esquerda" />
      </S.BackButtonIcon>
    ) : (
      <S.BackButton>
        <img src={arrow} alt="Seta para Esquerda" />
        <p>Voltar</p>
      </S.BackButton>
    )}

    <S.HeadingWrapper>
      <Heading id="searchPlace" level={6}>
        Selecione um restaurante
      </Heading>
    </S.HeadingWrapper>
    <S.OptionsWrapper data-testid="buttonOptions">
      {userIsLoggedIn && (
        <Button
          type="button"
          title="Acione para apresentar sua sessão de Popeyes favoritos"
          id="favoriteStores"
          variant="tertiary"
          onClick={() => onChangeSession('favoriteStores')}
        >
          Favoritos
        </Button>
      )}

      <Button
        type="button"
        title="Acione para apresentar Popeyes próximos a você"
        id="nearStores"
        variant="tertiary"
        onClick={() => onChangeSession('nearStores')}
      >
        Próximos
      </Button>
    </S.OptionsWrapper>
    <S.SearchInputWrapper>
      <S.Limiter>
        <InputGMPlaces
          forwardPlaces={changePlacesSuggestions}
          id="searchPlaces"
          name="searchPlaces"
          placeholder="Pesquise aqui"
          label="Digite o nome de referência de uma unidade Popeyes"
          disabled={height < 199}
        />
      </S.Limiter>
      <Button
        id="search"
        title="Acione esse botão para iniciar a busca de uma unidade Popeyes"
        type="button"
        variant="quaternary"
        className="search"
        onClick={onChangeViewMode}
        disabled={height < 199}
      >
        {mode === 'map' ? (
          <img src={pointer} alt="Icone representado um lugar no mapa" />
        ) : (
          <img src={listIcon} alt="Icone representando uma lista" />
        )}
      </Button>
    </S.SearchInputWrapper>
  </S.SearchHeader>
);
